import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArtisanEdgeModule } from '../../../../artisan-edge/src/lib/artisan-edge.module';
import { OktaLoginComponent } from './okta-login.component';
import { AppDataService } from '@tmhcc-ng-lib/data-service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule, LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { OktaLoginService } from '@tmhcc-ng-lib/okta-service';

@NgModule({
  declarations: [OktaLoginComponent],
  imports: [CommonModule, NgbModule, ArtisanEdgeModule, LoadingModule],
  exports: [],
  providers: [AppDataService, OktaLoginService, LoaderService]
})
export class FramworkOktaLoginModule {}
